<template>
  <div class="app-nav-root">
    <header class="app-nav" :class="{ 'nav-scrolled': isScrolled }">
      <v-container>
        <div class="nav-content">
          <div class="nav-brand" @click="navigateTo('/')">
            <span class="nav-badge">
              <img src="@/assets/petgroomoz.png" alt="" />
            </span>
            <div class="nav-logo-text">
              <div class="nav-name"><span class="pet">Pet</span><span class="groomoz">Groomoz</span></div>
              <div class="nav-tagline">GROOMING MADE SIMPLE</div>
            </div>
          </div>

          <nav class="nav-links">
            <router-link to="/" class="nav-link" exact>Home</router-link>
            <router-link to="/why" class="nav-link">Why PetGroomoz</router-link>
            <router-link to="/features" class="nav-link">Features</router-link>
            <router-link to="/about" class="nav-link">About</router-link>
            <router-link to="/blog" class="nav-link">Blog</router-link>
          </nav>

          <div class="nav-actions">
            <v-btn outlined class="nav-btn-login" to="/login">Login</v-btn>
            <v-btn depressed class="nav-btn-demo" to="/demo">Request Demo</v-btn>
          </div>

          <button class="nav-burger" aria-label="Open menu" @click="drawer = true">
            <v-icon color="#F7F0E6">mdi-menu</v-icon>
          </button>
        </div>
      </v-container>
    </header>

    <!-- Mobile drawer: a SIBLING of <header>, not a child. The header uses
         backdrop-filter, which makes it the containing block for any
         position:fixed descendants and would clip the drawer to ~70px. -->
    <div v-if="drawer" class="drawer-overlay" @click="drawer = false">
      <div class="drawer-panel" @click.stop>
        <div class="drawer-header">
          <span class="nav-badge nav-badge--lg">
            <img src="@/assets/petgroomoz.png" alt="" />
          </span>
          <div class="drawer-brand">
            <div><span class="pet">Pet</span><span class="groomoz">Groomoz</span></div>
            <div class="brand-sub">GROOMING MADE SIMPLE</div>
          </div>
          <button class="drawer-close" aria-label="Close menu" @click="drawer = false">
            <v-icon>mdi-close</v-icon>
          </button>
        </div>
        <v-divider class="my-4 drawer-divider"></v-divider>
        <div class="drawer-nav">
          <a class="drawer-link" @click="navigateTo('/')"><v-icon left>mdi-home</v-icon> Home</a>
          <a class="drawer-link" @click="navigateTo('/why')"><v-icon left>mdi-paw</v-icon> Why PetGroomoz</a>
          <a class="drawer-link" @click="navigateTo('/features')"><v-icon left>mdi-view-grid</v-icon> Features</a>
          <a class="drawer-link" @click="navigateTo('/about')"><v-icon left>mdi-information</v-icon> About</a>
          <a class="drawer-link" @click="navigateTo('/blog')"><v-icon left>mdi-post</v-icon> Blog</a>
          <v-divider class="my-4 drawer-divider"></v-divider>
          <a class="drawer-link" @click="navigateTo('/login')"><v-icon left>mdi-login</v-icon> Login</a>
          <a class="drawer-link drawer-link-accent" @click="navigateTo('/demo')"><v-icon left>mdi-calendar-check</v-icon> Request Demo</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppNavigation',
  data() {
    return { drawer: false, isScrolled: false };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 20;
    },
    navigateTo(route) {
      this.drawer = false;
      this.$router.push(route).catch(() => {});
    }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Figtree:wght@400;500;600;700;800&display=swap');

.app-nav-root { display: contents; }

.app-nav {
  --border-subtle: rgba(247, 240, 230, 0.08);
  --text-primary: #F7F0E6;
  --text-secondary: rgba(247, 240, 230, 0.7);
  --apricot: #F4A259;
  --apricot-light: #F7C28F;
  --apricot-dark: #EE8A4E;

  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 999;
  background: rgba(11, 29, 33, 0.86);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border-subtle);
  font-family: 'Figtree', -apple-system, BlinkMacSystemFont, sans-serif;
  transition: background 0.3s ease, box-shadow 0.3s ease;
}

.app-nav.nav-scrolled {
  background: rgba(8, 22, 25, 0.96);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.35);
}

.app-nav ::v-deep .v-btn { text-transform: none !important; letter-spacing: 0 !important; }

.nav-content { display: flex; justify-content: space-between; align-items: center; padding: 14px 0; }

.nav-brand { display: flex; align-items: center; gap: 12px; cursor: pointer; transition: transform 0.3s ease; }
.nav-brand:hover { transform: scale(1.03); }

.nav-badge {
  width: 40px; height: 40px; flex-shrink: 0;
  border-radius: 50%;
  background: #F7F0E6;
  overflow: hidden;
  display: flex; align-items: center; justify-content: center;
  box-shadow: 0 0 0 3px rgba(244, 162, 89, 0.2);
}
.nav-badge img { width: 100%; height: 100%; object-fit: cover; }
.nav-badge--lg { width: 46px; height: 46px; }

.nav-logo-text { display: flex; flex-direction: column; line-height: 1.15; }
.nav-name { font-size: 1.25rem; font-weight: 800; letter-spacing: -0.01em; }
.pet { color: #6BD6C4; }
.groomoz { color: #F4A259; }
.nav-tagline { white-space: nowrap; font-size: 0.6rem; font-weight: 700; letter-spacing: 2.2px; color: rgba(247, 240, 230, 0.5); }

.nav-links { display: flex; align-items: center; gap: 6px; }

.nav-link {
  padding: 10px 16px;
  color: var(--text-secondary);
  font-size: 14.5px;
  font-weight: 600;
  text-decoration: none;
  border-radius: 8px;
  transition: all 0.2s ease;
  white-space: nowrap;
}
.nav-link:hover,
.nav-link.router-link-active { color: var(--apricot-light); background: rgba(244, 162, 89, 0.1); }

.nav-actions { display: flex; align-items: center; gap: 10px; }

.nav-btn-login {
  border: 1.5px solid var(--apricot) !important;
  color: var(--apricot-light) !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
}
.nav-btn-demo {
  background: linear-gradient(135deg, #F7B267 0%, #EE8A4E 100%) !important;
  color: #2A1608 !important;
  font-weight: 800 !important;
  border-radius: 10px !important;
}

.nav-burger {
  display: none;
  width: 40px; height: 40px;
  align-items: center; justify-content: center;
  background: rgba(247, 240, 230, 0.06);
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
  cursor: pointer;
}

/* ==================== MOBILE DRAWER ==================== */
.drawer-overlay {
  position: fixed; inset: 0;
  background: rgba(4, 14, 16, 0.72);
  backdrop-filter: blur(8px);
  z-index: 1000;
}

.drawer-panel {
  position: fixed; top: 0; left: 0; bottom: 0;
  width: 300px;
  background: #0F262B;
  border-right: 1px solid rgba(247, 240, 230, 0.08);
  box-shadow: 0 0 60px rgba(0, 0, 0, 0.5);
  z-index: 1001;
  overflow-y: auto;
  padding: 8px;
  font-family: 'Figtree', sans-serif;
}

.drawer-header { display: flex; align-items: center; gap: 12px; padding: 24px 16px 0; }
.drawer-brand { flex: 1; line-height: 1.2; }
.drawer-brand > div:first-child { font-size: 18px; font-weight: 800; }
.brand-sub { white-space: nowrap; font-size: 9px; font-weight: 700; letter-spacing: 1.6px; color: rgba(247, 240, 230, 0.5); }
.drawer-divider { border-color: rgba(247, 240, 230, 0.08) !important; }

.drawer-close {
  width: 36px; height: 36px;
  display: flex; align-items: center; justify-content: center;
  background: rgba(247, 240, 230, 0.06);
  border: 1px solid rgba(247, 240, 230, 0.08);
  border-radius: 8px;
  color: rgba(247, 240, 230, 0.7);
  cursor: pointer;
}
.drawer-close ::v-deep .v-icon,
.drawer-link ::v-deep .v-icon { color: currentColor !important; }

.drawer-nav { padding: 8px 16px 16px; }

.drawer-link {
  display: flex; align-items: center;
  padding: 14px 16px;
  color: rgba(247, 240, 230, 0.7);
  font-size: 16px; font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  margin-bottom: 4px;
}
.drawer-link:hover { background: rgba(244, 162, 89, 0.1); color: #F7C28F; transform: translateX(6px); }
.drawer-link-accent { color: #F7C28F; }

.nav-burger:focus-visible,
.drawer-close:focus-visible { outline: 2px solid #F4A259; outline-offset: 2px; }

@media (max-width: 960px) {
  .nav-links, .nav-actions { display: none; }
  .nav-burger { display: flex; }
}
</style>